import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let FaqFrontendFeature = /*#__PURE__*/(() => {
  let FaqFrontendFeature = class FaqFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/faq/frontend","featureId":"common-faq"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵFaqFrontendFeature_BaseFactory;
        return function FaqFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵFaqFrontendFeature_BaseFactory || (ɵFaqFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(FaqFrontendFeature)))(__ngFactoryType__ || FaqFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: FaqFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'help',
          loadChildren: () => import('./faq-frontend.module').then(m => m.FaqFrontendModule)
        }])]
      });
    }
  };
  FaqFrontendFeature = __decorate([ClassName("FaqFrontendFeature")], FaqFrontendFeature);
  return FaqFrontendFeature;
})();
export { FaqFrontendFeature };